import RestClient from './RestClient';
import { Invoice } from '../../models';

class Invoices extends RestClient {
    constructor() {
        super({
            "model": Invoice,
            "entryPoint": "invoice",
            "resource": "invoice",
            "resources": "invoices",
            "sortBy": "created_at",
        });
    }

    generate() {
        let url = '/invoice/generate';
        return this.POST(url)
            .then(response => response.json())
            .then(json => {
                if (json.invoices)
                    return {
                        ...json,
                        invoices: json.invoices.map(invoice => new Invoice(invoice))
                    };
                throw new Error(json.flash.error);
            });
    }
}

const InvoicesApi = new Invoices();

export default InvoicesApi;
